import styled from 'styled-components';

export const StyledRadioTemplate = styled.div`
	background-color: #FFFFFF;
	padding: 10px 0;
	max-width: 224px;
	box-shadow: 0 0 4px rgba(0, 0, 0, .2);
	border-radius: 12px;
	display: flex;
	flex-direction: column;

	.radio {
		min-width: 200px;
    margin: 0 auto;

		label {
			display: flex;
			align-items: center;
		}
		
		input[type="radio"] {
			position: absolute;
			opacity: 0;
			+ .radio-label {
				&:before {
					content: '';
					background: #DDDDDD;
					border-radius: 100%;
					border: 1px solid darken(#f4f4f4, 25%);
					display: inline-block;
					width: 1.4em;
					height: 1.4em;
					position: relative;
					top: -0.2em;
					margin-right: 1em; 
					vertical-align: top;
					cursor: pointer;
					text-align: center;
					transition: all 250ms ease;
				}
			}
			&:checked {
				+ .radio-label {
					&:before {
						background-color: #3197EE;
						box-shadow: inset 0 0 0 4px #f4f4f4;
					}
				}
			}
			&:focus {
				+ .radio-label {
					&:before {
						outline: none;
						border-color: #3197EE;
					}
				}
			}
			&:disabled {
				+ .radio-label {
					&:before {
						box-shadow: inset 0 0 0 4px #f4f4f4;
						border-color: darken(#f4f4f4, 25%);
						background: darken(#f4f4f4, 25%);
					}
				}
			}
			+ .radio-label {
				&:empty {
					&:before {
						margin-right: 0;
					}
				}
			}
		}
	}
`;

export const StyledDateRangePicker = styled.div`
	display: inline-block;
	.DateRangePicker{
		margin-right: 24px;
	}
	.DateInput_input {
		font-family: Poppins,Heltica,Arial,sans-serif;
		font-size: 12px;
		color: #425A70;
		padding: 2px 11px 2px;
		border-radius: 12px;
		border-bottom-color: transparent;
	}
	.DateInput.DateInput_1 {
		border-radius: 12px;
		width: 120px;
	}
	.DateRangePickerInput__withBorder {
		border-radius: 12px;
	}
	.DateRangePicker.DateRangePicker_1 {
	    border-radius: 12px;
	    
	    .DayPicker,
	    .DayPicker .DayPicker_transitionContainer {
	      width: 660px !important;
	      height: 340px !important;
	    }
	    
	    //.DayPicker.DayPicker_1 {
	    //  div:first-child div:first-child {
	    //    width: 100% !important;
	    //  }
	    //}
	    
	    //.DayPicker.DayPicker_1.DayPicker__horizontal.DayPicker__horizontal_2.DayPicker__withBorder.DayPicker__withBorder_3 {
	    //  div:first-child div:first-child {
	    //    width: 100%;
	    //  }
	    //}
	    
	    .DayPicker .DayPickerNavigation_rightButton__horizontalDefault {
	      right: -22px !important;
	    }
	    
	    .DayPicker_weekHeader.DayPicker_weekHeader_1 {
	      left: 325px !important;
	    }
	    
	    .DayPicker_weekHeader_ul.DayPicker_weekHeader_ul_1 {
	      width: 290px !important;
	      
	      li {
	        width: 40px !important;
	      }
	    }
	}
`;
